module.exports = __webpack_public_path__ + "media/bootstrap-icons/bell-d1dd7bb4.svg";